import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { Type } from './redux';
import { Type as SysType } from '../redux';

const getCallrollList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_CALLROLL_LIST),
    switchMap(() => {
      return fetch({
        url:
          '/mm-classroom/web/j/mocRollCallRpcBean.getRollCallRecordByRollCallId.rpc',
        body: {
          rollCallId:
            state$.value.mirroring.ws.socketData?.callrollDataTransportFromWl
              ?.callrollId,
          sort: 1,
        },
      });
    }),
    map(data => ({ type: Type.GET_CALLROLL_LIST_SUCCESS, data })),
  );

const startCallroll = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.START_CALLROLL),
    switchMap(() => {
      const planId =
        state$.value.mirroring.ws.socketData?.callrollDataTransportFromWl
          ?.planId;
      const body = {
        lotteryId: state$.value.mirroring.callroll.id || -1,
        targetId:
          state$.value.mirroring.classroom.lessonId ||
          state$.value.mirroring.classroom?.classroom?.currentLessonId,
        lotteryRange: 1,
      };
      if (planId) {
        body.planId = planId;
      }
      return fetch({
        url: '/mm-classroom/web/j/mocRollCallRpcBean.startRollCall.rpc',
        body,
      });
    }),
    map(data => ({ type: Type.START_CALLROLL_SUCCESS, data })),
  );

const getRandomStu = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_STU_LIST),
    switchMap(() => {
      return fetch({
        url: '/mm-classroom/web/j/mocRollCallRpcBean.getRandomStu.rpc',
        body: {
          classroomId: state$.value.mirroring.classroom.classroomId,
          pIndex: 1,
          pSize: 400,
        },
      });
    }),
    map(data => ({ type: Type.GET_STU_LIST_SUCCESS, data })),
  );

const cancelRollCall = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CANCEL_ROLLCALL),
    switchMap(() => {
      return fetch({
        url: '/mm-classroom/web/j/mocRollCallRpcBean.cancelRollCall.rpc',
        body: {
          classroomId: state$.value.mirroring.classroom.classroomId,
          lotteryRecordId: state$.value.mirroring.callroll.lotteryRecordId,
        },
      });
    }),
    map(data => ({ type: Type.CANCEL_ROLLCALL_SUCCESS, data })),
  );

const closeRollCall = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CLOSE_ROLLCALL),
    switchMap(({ id }) => {
      return fetch({
        url: '/mm-classroom/web/j/mocRollCallRpcBean.closeRollCall.rpc',
        body: {
          rollCallId: id,
        },
      });
    }),
    map(data => ({ type: Type.CLOSE_ROLLCALL_SUCCESS, data })),
  );

const getRollcallListByLessonId = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_ROLLCALL_LIST_BY_LESSON_ID),
    switchMap(() => {
      return fetch({
        url:
          '/mm-classroom/web/j/mocRollCallRpcBean.getRollCallListByLessonId.rpc',
        body: {
          lessonId:
            state$.value.mirroring.classroom.lessonId ||
            state$.value.mirroring.classroom?.classroom?.currentLessonId,
        },
      });
    }),
    map(data => ({ type: Type.GET_ROLLCALL_LIST_BY_LESSON_ID_SUCCESS, data })),
  );

export default [
  getCallrollList,
  startCallroll,
  getRandomStu,
  cancelRollCall,
  closeRollCall,
  getRollcallListByLessonId,
];
